import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import {
  type InternLenke,
  LenkerContainer,
} from "@/components/LenkerContainer";

export const DokumentasjonsLenker = ({
  className,
  lenker,
}: PropsWithChildren<{ className?: string; lenker?: InternLenke[] }>) => {
  const { t } = useTranslation();

  const dokumentasjonsLenker: InternLenke[] = lenker ?? [
    {
      href: "/dokumentasjon/eksporter",
      text: t("pages.dokumentasjon.lenker.avtale-eksport"),
      external: false,
    },
    {
      href: "/dokumentasjon/innrapportering",
      text: t("pages.dokumentasjon.lenker.innrapportering"),
      external: false,
    },
    {
      href: "/validering",
      text: t("pages.dokumentasjon.lenker.test-innrapportering"),
      external: false,
    },
  ];

  return (
    <LenkerContainer
      title={t("pages.dokumentasjon.lenker.tittel")}
      links={dokumentasjonsLenker}
      className={className}
      variant="tinted"
    />
  );
};
